export const enum ePlanType {
  FULL = 'FULL',
  OFFER = 'OFFER',
}

export enum eDiscount {
  MONTHLY = 0,
  QUARTERLY = 10,
  BIANNUALLY = 15,
  ANNUALLY = 20,
}

export const enum ePlanCurrency {
  MXN = 'MXN',
  USD = 'USD',
  BR = 'BR',
}

export enum eCountryCode {
  MX = 'MX',
  US = 'US',
}

export enum eCardBrand {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMERICAN_EXPRESS = 'american_express',
}

export enum eProductType {
  TEMPLATE_CREDITS_LIMIT = 'TEMPLATE_CREDITS_LIMIT',
  LEADBOT_PREMIUM = 'LEADBOT_PREMIUM',
  LEADBOT_LEVELS = 'LEADBOT_LEVELS',
  LEAD_LIMIT_ADDON = 'LEAD_LIMIT_ADDON',
  SEATS = 'SEATS',
}

export const enum eSubscriptionCreationStatus {
  SUBSCRIPTION_ALREADY_ACTIVE = 'subscription_already_active',
  PLAN_TYPE_NOT_FOUND = 'plan_type_not_found',
  TRIAL_ALREADY_ACQUIRED = 'trial_already_acquired',
  CARD_DECLINED_GENERIC_DECLINE = 'card_declined_generic_decline',
  CARD_DECLINED_INSUFFICIENT_FUNDS = 'card_declined_insufficient_funds',
  CARD_DECLINED_LOST_CARD = 'card_declined_lost_card',
  CARD_DECLINED_STOLEN_CARD = 'card_declined_stolen_card',
  CARD_DECLINED_CARD_VELOCITY_EXCEEDED = 'card_declined_card_velocity_exceeded',
  EXPIRED_CARD = 'expired_card',
  INCORRECT_CVC = 'incorrect_cvc',
  PROCESSING_ERROR = 'processing_error',
  INCORRECT_NUMBER = 'incorrect_number',
  CARD_DECLINED_AUTHENTICATION_REQUIRED = 'card_declined_authentication_required',
  CARD_DECLINED_APPROVE_WITH_ID = 'card_declined_approve_with_id',
  CARD_DECLINED_CALL_ISSUER = 'card_declined_call_issuer',
  CARD_DECLINED_CARD_NOT_SUPPORTED = 'card_declined_card_not_supported',
  CARD_DECLINED_CURRENCY_NOT_SUPPORTED = 'card_declined_currency_not_supported',
  CARD_DECLINED_DO_NOT_HONOR = 'card_declined_do_not_honor',
  CARD_DECLINED_DO_NOT_TRY_AGAIN = 'card_declined_do_not_try_again',
  CARD_DECLINED_DUPLICATE_TRANSACTION = 'card_declined_duplicate_transaction',
  CARD_DECLINED_EXPIRED_CARD = 'card_declined_expired_card',
  CARD_DECLINED_FRAUDULENT = 'card_declined_fraudulent',
  CARD_DECLINED_INCORRECT_NUMBER = 'card_declined_incorrect_number',
  CARD_DECLINED_INCORRECT_CVC = 'card_declined_incorrect_cvc',
  CARD_DECLINED_INCORRECT_PIN = 'card_declined_incorrect_pin',
  CARD_DECLINED_INCORRECT_ZIP = 'card_declined_incorrect_zip',
  CARD_DECLINED_INVALID_ACCOUNT = 'card_declined_invalid_account',
  CARD_DECLINED_INVALID_AMOUNT = 'card_declined_invalid_amount',
  CARD_DECLINED_INVALID_EXPIRY_MONTH = 'card_declined_invalid_expiry_month',
  CARD_DECLINED_INVALID_EXPIRY_YEAR = 'card_declined_invalid_expiry_year',
  CARD_DECLINED_INVALID_NUMBER = 'card_declined_invalid_number',
  CARD_DECLINED_ISSUER_NOT_AVAILABLE = 'card_declined_issuer_not_available',
  CARD_DECLINED_MERCHANT_BLACKLIST = 'card_declined_merchant_blacklist',
  CARD_DECLINED_NO_ACTION_TAKEN = 'card_declined_no_action_taken',
  CARD_DECLINED_NOT_PERMITTED = 'card_declined_not_permitted',
  CARD_DECLINED_OFFLINE_PIN_REQUIRED = 'card_declined_offline_pin_required',
  CARD_DECLINED_PICKUP_CARD = 'card_declined_pickup_card',
  CARD_DECLINED_PIN_TRY_EXCEEDED = 'card_declined_pin_try_exceeded',
  CARD_DECLINED_PROCESSING_ERROR = 'card_declined_processing_error',
  CARD_DECLINED_REENTER_TRANSACTION = 'card_declined_reenter_transaction',
  CARD_DECLINED_RESTRICTED_CARD = 'card_declined_restricted_card',
  CARD_DECLINED_SECURITY_VIOLATION = 'card_declined_security_violation',
  CARD_DECLINED_SERVICE_NOT_ALLOWED = 'card_declined_service_not_allowed',
  CARD_DECLINED_STOP_PAYMENT_ORDER = 'card_declined_stop_payment_order',
  CARD_DECLINED_TESTMODE_DECLINE = 'card_declined_testmode_decline',
  CARD_DECLINED_TRANSACTION_NOT_ALLOWED = 'card_declined_transaction_not_allowed',
  CARD_DECLINED_TRY_AGAIN_LATER = 'card_declined_try_again_later',
  CARD_DECLINED_WITHDRAWAL_COUNT_LIMIT_EXCEEDED = 'card_declined_withdrawal_count_limit_exceeded',
}
